import PausedBanner from './PausedBanner'
export default PausedBanner
